import { z } from "zod";

// Wire timestamps permit minute precision and, where offsets are allowed,
// compact or colon-separated numeric offsets. Keep this grammar independent
// of changes to the validator library's default RFC 3339 policy.
const date = z.regexes.date.source.slice(1, -1);
const time = String.raw`(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?`;
export const WIRE_DATETIME_PATTERN = new RegExp(`^${date}T${time}Z$`);
export const WIRE_OFFSET_DATETIME_PATTERN = new RegExp(`^${date}T${time}(?:Z|[+-]\\d{2}:?\\d{2})$`);
